const guiColors = {
    'color-scheme': 'dark',

    'ui-primary': '#000000',
    'ui-secondary': '#060606',
    'ui-tertiary': '#080808',

    'ui-modal-overlay': '#060606aa',
    'ui-modal-background': '#000000',
    'ui-modal-foreground': '#eeeeee',
    'ui-modal-header-background': '#060606',
    'ui-modal-header-foreground': '#ffffff',

    'ui-white': '#000000',

    'ui-black-transparent': '#ffffff26',

    'text-primary': '#eeeeee',

    'menu-bar-background': 'var(--looks-secondary-dark)',
    'menu-bar-background-image': 'none',
    'menu-bar-foreground': '#ffffff',

    'assets-background': '#000000',

    'input-background': 'var(--ui-secondary)',

    'popover-background': 'var(--ui-secondary)',

    'badge-background': '#16202c',
    'badge-border': '#203652',

    'fullscreen-background': '#000000',
    'fullscreen-accent': '#000000',

    'page-background': '#000000',
    'page-foreground': '#eeeeee',

    'project-title-inactive': 'var(--ui-secondary)',
    'project-title-hover': '#ffffff3f',

    'link-color': 'var(--looks-secondary-lighter)',

    'git-diff-added-background': '#041A0D',
    'git-diff-removed-background': '#0B2411',
    'git-status-untracked-background': '#000B21',
    'git-status-untracked-foreground': '#8E8EE0',
    'git-status-modified-background': '#103000',
    'git-status-modified-foreground': '#75F567',
    'git-status-deleted-background': '#07300B',
    'git-status-deleted-foreground': '#9CFFA1',

    'filter-icon-black': 'invert(100%)',
    'filter-icon-gray': 'grayscale(100%) brightness(1.7)',
    'filter-icon-white': 'brightness(0) invert(100%)',

    'paint-filter-icon-gray': 'brightness(1.7)'
};

const blockColors = {
    insertionMarker: '#cccccc',
    workspace: 'var(--ui-secondary)',
    toolboxSelected: 'var(--ui-secondary)',
    toolboxText: '#cccccc',
    toolbox: '#000000',
    flyout: '#000000',
    scrollbar: '#444444',
    valueReportBackground: 'var(--ui-secondary)',
    valueReportBorder: '#030303',
    valueReportForeground: '#eeeeee',
    errorReportBackground: '#1F0909',
    errorReportBorder: '#400D0D',
    errorReportForeground: '#eecccc',
    contextMenuBackground: '#000000',
    contextMenuBorder: '#ffffff26',
    contextMenuForeground: '#eeeeee',
    contextMenuActiveBackground: '#171717',
    contextMenuDisabledForeground: '#444444',
    flyoutLabelColor: '#cccccc',
    checkboxInactiveBackground: '#222222',
    checkboxInactiveBorder: '#c8c8c8',
    buttonBorder: '#c6c6c6',
    buttonActiveBackground: '#222222',
    buttonForeground: '#cccccc',
    zoomIconFilter: 'invert(100%)',
    gridColor: 'transparent'
};

export {
    guiColors,
    blockColors
};